/* eslint-disable import/prefer-default-export */

export enum DocReportType {
    DocReportUnknown = 0,
    DocNewDoc = 1, //  新建文档
    DocOpenDoc = 2, //  打开文档
    DocOpenHomePage = 3, //  打开文档主页
    DocOpenTemplatePage = 4, //  打开模板页
    DocExport = 5, //  导出文档
    DocForwardWw = 6, //  转发到企微
    DocForwardWx = 7, //  转发到微信
}
